<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        AR Aging (versi Collector)
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="showPrintConfirm = true"><i class="fa fa-print"></i> Print</button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()"><i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <span v-if="model.exclude == 1" class="p-2">A/R Account Exclude</span>
              <span v-else class="p-2">A/R Account Equal</span>
            </b-input-group-prepend>
            <b-form-checkbox v-model="model.exclude" :value="1" :unchecked-value="0" switch class="pt-2"></b-form-checkbox>
            <b-form-select v-model="model.account" :plain="true" :options="accounts" style="width: 30% !important"></b-form-select>
            <b-input-group-prepend><span class="input-group-text">GL Acc.#</span></b-input-group-prepend>
            <b-form-input v-model="model.kodeacc" readonly placeholder="GL Account Code"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="5">
          <b-input-group>
            <b-input-group-prepend><span class="p-2">As Of Date</span></b-input-group-prepend>
            <b-form-input v-model="model.tgl2" type="date"></b-form-input>
            <b-form-checkbox class="ml-1 mt-2 text-left" v-model="model.excludezero" value="1" unchecked-value="0">Exclude Zero Outstandings</b-form-checkbox>
            <b-input-group-append
              ><b-button class="ml-3 btn btn-success" @click="getData()"> <i class="fa fa-play"></i> Process</b-button></b-input-group-append
            >
          </b-input-group>
        </b-col>
      </b-row>

      <b-card no-body v-show="showSummary">
        <b-tabs card v-model="model.tabIndex">
          <b-tab title="Summary in Original Currency" active>
            <b-row v-if="filterShow == 'Hide'">
              <b-col lg="6">
                <b-form-group label="Filter" label-cols-sm="1" label-size="sm" label-for="filterInput" class="mb-0">
                  <b-input-group size="sm">
                    <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                  <b> {{ filterShow }}</b> Filter
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-table
              class="mb-0"
              ref="tableOri"
              sticky-header="600px"
              outlined
              responsive
              striped
              hover
              style="font-size: smaller"
              :items="aging.rekap"
              :fields="tblOri.fields"
              :current-page="tblOri.page"
              :per-page="tblOri.limit"
              :sort-by.sync="tblOri.sortBy"
              :sort-desc.sync="tblOri.sortDesc"
              :filter="filter"
              :filterIncludedFields="filterOn"
              @filtered="onFiltered"
            >
              <template v-slot:cell(totalOri)="data">
                {{ data.item.totalOri | numFormat }}
              </template>
              <template v-slot:head(aging1Ori)="data">
                <span v-if="aging.seting.arAge1" class="text-info">CURRENT</span>
                <span v-else class="text-info">CURRENT</span>
              </template>
              <template v-slot:cell(aging1Ori)="data">
                <a href="javascript:void(0)" @click.stop="getDetail(data.item, 1)">
                  {{ data.item.aging1Ori | numFormat }}
                </a>
              </template>
              <template v-slot:head(aging2Ori)="data">
                <span v-if="aging.seting.arAge2" class="text-info">{{ aging.seting.arAge2 - aging.seting.arAge1 }} Days</span>
                <span v-else class="text-info">30 Days</span>
              </template>
              <template v-slot:cell(aging2Ori)="data">
                <a href="javascript:void(0)" @click.stop="getDetail(data.item, 2)">
                  {{ data.item.aging2Ori | numFormat }}
                </a>
              </template>
              <template v-slot:head(aging3Ori)="data">
                <span v-if="aging.seting.arAge3" class="text-info">{{ aging.seting.arAge3 - aging.seting.arAge2 }} Days</span>
                <span v-else class="text-info">60 Days</span>
              </template>
              <template v-slot:cell(aging3Ori)="data">
                <a href="javascript:void(0)" @click.stop="getDetail(data.item, 3)">
                  {{ data.item.aging3Ori | numFormat }}
                </a>
              </template>
              <template v-slot:head(aging4Ori)="data">
                <span v-if="aging.seting.arAge4" class="text-info">{{ aging.seting.arAge4 - aging.seting.arAge3 }} Days</span>
                <span v-else class="text-info">90 Days</span>
              </template>
              <template v-slot:cell(aging4Ori)="data">
                <a href="javascript:void(0)" @click.stop="getDetail(data.item, 4)">
                  {{ data.item.aging4Ori | numFormat }}
                </a>
              </template>
              <template v-slot:head(aging5Ori)="data">
                <span v-if="aging.seting.arAge5" class="text-info">{{ aging.seting.arAge5 - aging.seting.arAge4 }} Days</span>
                <span v-else class="text-info"> 120 Days</span>
              </template>
              <template v-slot:cell(aging5Ori)="data">
                <a href="javascript:void(0)" @click.stop="getDetail(data.item, 5)">
                  {{ data.item.aging5Ori | numFormat }}
                </a>
              </template>

              <template v-slot:head(aging6Ori)="data">
                <span v-if="aging.seting.arAge5" class="text-info"> > {{ aging.seting.arAge5 - aging.seting.arAge1 }} Days</span>
                <span v-else class="text-info"> > 180 Days</span>
              </template>
              <template v-slot:cell(aging6Ori)="data">
                <a href="javascript:void(0)" @click.stop="getDetail(data.item, 5)">
                  {{ data.item.aging6Ori | numFormat }}
                </a>
              </template>
            </b-table>
            <b-row class="mt-2">
              <b-col cols="4">
                <div style="font-weight: bolder">Total Outstanding : {{ uanguser }} {{ aging.totalLcy | numFormat }}</div>
              </b-col>
              <b-col cols="8">
                <b-row>
                  <b-col cols="6" style="text-align: center">
                    <div>
                      Showing {{ (tblOri.page - 1) * tblOri.limit + 1 }} to <span v-if="tblOri.page * tblOri.limit > tblOri.total">{{ tblOri.total }}</span>
                      <span v-else>{{ tblOri.page * tblOri.limit }}</span> of {{ tblOri.total }} entries, <span class="ml-3 mr-1">limit per page :</span>
                      <select v-model="tblOri.limit" style="width: 60px">
                        <option>10</option>
                        <option>15</option>
                        <option>20</option>
                        <option>25</option>
                        <option>30</option>
                      </select>
                    </div>
                    <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                      <b> {{ filterShow }}</b> Filter
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="6">
                    <b-pagination align="right" :total-rows="tblOri.total" :per-page="tblOri.limit" v-model="tblOri.page"></b-pagination>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Summary in Local Currency (LCY)">
            <b-row v-if="filterShow == 'Hide'">
              <b-col lg="6">
                <b-form-group label="Filter" label-cols-sm="1" label-size="sm" label-for="filterInput" class="mb-0">
                  <b-input-group size="sm">
                    <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                  <b> {{ filterShow }}</b> Filter
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-table
              class="mb-0"
              ref="tableLcy"
              sticky-header="600px"
              outlined
              responsive
              striped
              hover
              style="font-size: smaller"
              :items="aging.rekap"
              :fields="tblLcy.fields"
              :current-page="tblLcy.page"
              :per-page="tblLcy.limit"
              :sort-by.sync="tblLcy.sortBy"
              :sort-desc.sync="tblLcy.sortDesc"
              :filter="filter"
              :filterIncludedFields="filterOn"
              @filtered="onFiltered"
            >
              <template v-slot:head(totalLcy)="data">
                <span>Total Outstand in {{ uanguser }} (Local Currency)</span>
              </template>
              <template v-slot:cell(totalLcy)="data">
                {{ data.item.totalLcy | numFormat }}
              </template>
              <template v-slot:head(aging1Lcy)="data">
                <span v-if="aging.seting.arAge1" class="text-info">CURRENT</span>
                <span v-else class="text-info">CURRENT</span>
              </template>
              <template v-slot:cell(aging1Lcy)="data">
                <a href="javascript:void(0)" @click.stop="getDetail(data.item, 1)">
                  {{ data.item.aging1Lcy | numFormat }}
                </a>
              </template>
              <template v-slot:head(aging2Lcy)="data">
                <span v-if="aging.seting.arAge2" class="text-info">{{ aging.seting.arAge2 - aging.seting.arAge1 }} Days</span>
                <span v-else class="text-info">30 Days</span>
              </template>
              <template v-slot:cell(aging2Lcy)="data">
                <a href="javascript:void(0)" @click.stop="getDetail(data.item, 2)">
                  {{ data.item.aging2Lcy | numFormat }}
                </a>
              </template>
              <template v-slot:head(aging3Lcy)="data">
                <span v-if="aging.seting.arAge3" class="text-info">{{ aging.seting.arAge3 - aging.seting.arAge2 }} Days</span>
                <span v-else class="text-info">60 Days</span>
              </template>
              <template v-slot:cell(aging3Lcy)="data">
                <a href="javascript:void(0)" @click.stop="getDetail(data.item, 3)">
                  {{ data.item.aging3Lcy | numFormat }}
                </a>
              </template>
              <template v-slot:head(aging4Lcy)="data">
                <span v-if="aging.seting.arAge4" class="text-info">{{ aging.seting.arAge4 - aging.seting.arAge3 }} Days</span>
                <span v-else class="text-info">90 Days</span>
              </template>
              <template v-slot:cell(aging4Lcy)="data">
                <a href="javascript:void(0)" @click.stop="getDetail(data.item, 4)">
                  {{ data.item.aging4Lcy | numFormat }}
                </a>
              </template>
              <template v-slot:head(aging5Lcy)="data">
                <span v-if="aging.seting.arAge5" class="text-info">{{ aging.seting.arAge5 - aging.seting.arAge4 }} Days</span>
                <span v-else class="text-info"> 120 Days</span>
              </template>
              <template v-slot:cell(aging5Lcy)="data">
                <a href="javascript:void(0)" @click.stop="getDetail(data.item, 5)">
                  {{ data.item.aging5Lcy | numFormat }}
                </a>
              </template>

              <template v-slot:head(aging6Lcy)="data">
                <span v-if="aging.seting.arAge5" class="text-info"> > {{ aging.seting.arAge5 - aging.seting.arAge1 }} Days</span>
                <span v-else class="text-info"> > 180 Days</span>
              </template>
              <template v-slot:cell(aging6Lcy)="data">
                <a href="javascript:void(0)" @click.stop="getDetail(data.item, 5)">
                  {{ data.item.aging6Lcy | numFormat }}
                </a>
              </template>
            </b-table>
            <b-row class="mt-2">
              <b-col cols="4">
                <div style="font-weight: bolder">Total Outstanding : {{ uanguser }} {{ aging.totalLcy | numFormat }}</div>
              </b-col>
              <b-col cols="8">
                <b-row>
                  <b-col cols="6" style="text-align: center">
                    <div>
                      Showing {{ (tblLcy.page - 1) * tblLcy.limit + 1 }} to <span v-if="tblLcy.page * tblLcy.limit > tblLcy.total">{{ tblLcy.total }}</span>
                      <span v-else>{{ tblLcy.page * tblLcy.limit }}</span> of {{ tblLcy.total }} entries, <span class="ml-3 mr-1">limit per page :</span>
                      <select v-model="tblLcy.limit" style="width: 60px">
                        <option>10</option>
                        <option>15</option>
                        <option>20</option>
                        <option>25</option>
                        <option>30</option>
                      </select>
                    </div>
                    <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                      <b> {{ filterShow }}</b> Filter
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="6">
                    <b-pagination align="right" :total-rows="tblLcy.total" :per-page="tblLcy.limit" v-model="tblLcy.page"></b-pagination>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-card>
      <b-card no-body v-if="!showSummary">
        <h4>Detail AR Outstanding</h4>
        <div class="report-wraper">
          <table style="width: 100%">
            <thead>
              <tr>
                <th width="120px">Inv. Number</th>
                <th width="90px">Inv Date</th>
                <th width="100px">PO. Number</th>
                <th>Customer</th>
                <th>Description</th>
                <th width="30px">$,¥</th>
                <th width="110px" style="text-align: right">Total Invoice</th>
                <th width="110px" style="text-align: right">Outstand</th>
                <th width="110px" style="text-align: right">Outstand LCY</th>
                <th width="40px" style="text-align: right">Age (days)</th>
                <th width="100px">Outstand Status</th>
                <th>Collection Note</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in agingDtl.list" :key="row.arinvKey">
                <td>{{ row.nomor }}</td>
                <td>{{ row.tanggal | moment("DD MMM YYYY") }}</td>
                <td>{{ row.ordernumber }}</td>
                <td>{{ row.custinfo }}</td>
                <td>{{ row.uraian }}</td>
                <td>{{ row.matauang }}</td>
                <td style="text-align: right">{{ row.totalinv | numFormat }}</td>
                <td style="text-align: right">{{ row.outstand | numFormat }}</td>
                <td style="text-align: right">{{ row.outstandLcy | numFormat }}</td>
                <td style="text-align: right">{{ row.aging }}</td>
                <td>{{ row.ostStatusname }}</td>
                <td>{{ row.colleNote }}</td>
              </tr>
              <tr>
                <td style="text-align: right" colspan="6">SUB TOTAL : &nbsp;</td>
                <td class="total" style="text-align: right"></td>
                <td class="total" style="text-align: right">{{ agingDtl.outstand | numFormat }}</td>
                <td class="total" style="text-align: right">{{ agingDtl.outstandLcy | numFormat }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-card>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal v-model="showPrintConfirm" title="Print Choices" size="sm" @ok="print">
      <b-form-radio-group id="chkPrint" name="printMenus" v-model="model.view" stacked>
        <b-form-radio value="Summary in Original Currency">Summary in Original Currency</b-form-radio>
        <b-form-radio value="Summary in Local Currency">Summary in Local Currency</b-form-radio>
        <b-form-radio value="Detail Invoice Outstanding">Detail Invoice Outstanding</b-form-radio>
      </b-form-radio-group>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import arreport from "../../apis/arreport";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
      tgl2: { required },
    },
  },
  data() {
    return {
      horizontal: true,
      isLoading: false,
      showSummary: true,
      showPrintConfirm: false,
      showReport: false,
      reportUrl: null,
      model: { tabIndex: 0, account: "", tgl1: "", tgl2: "", exclude: 0, excludezero: 1 },
      uanguser: this.$store.state.user.matauang,
      accounts: [],
      aging: { rekap: [], detail: [], seting: {} },
      agingDtl: { list: [], outstand: 0, outstandLcy: 0 },
      subtotal: {},
      tblOri: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "custcode",
            label: "Customer Code",
            thStyle: "width:120px",
            sortable: true,
          },
          {
            key: "CustName",
            label: "Customer Name",
            sortable: true,
          },
          {
            key: "postgrpname",
            label: "AR Account Name",
            sortable: true,
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true,
          },
          {
            key: "totalOri",
            label: "Total Outstanding",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "aging1Ori",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "aging2Ori",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "aging3Ori",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "aging4Ori",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "aging5Ori",
            label: " > 180 Days",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
        ],
      },
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "custcode",
            label: "Customer Code",
            thStyle: "width:120px",
            sortable: true,
          },
          {
            key: "CustName",
            label: "Customer Name",
            sortable: true,
          },
          {
            key: "postgrpname",
            label: "AR Account Name",
            sortable: true,
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true,
          },
          {
            key: "totalLcy",
            label: "Total Outstanding",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "aging1Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "aging2Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "aging3Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "aging4Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "aging5Lcy",
            label: " > 180 Days",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
        ],
      },
      filter: null,
      filterOn: ["custcode", "CustName", "postgrpname"],
      filterShow: "Show",
    };
  },
  components: { Loading },
  computed: {
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    account() {
      return this.model.account;
    },
  },
  watch: {
    account: function (newval) {
      const obj = this.accounts.find((d) => d.value === newval);
      this.model.namaacc = obj.text || "";
      this.model.kodeacc = obj.kodeacc;
    },
  },
  created: async function () {
    const accList = await arreport.postgroupnonkoran();
    this.accounts = accList.reduce(
      (newArr, item) => {
        newArr.push(item);
        return newArr;
      },
      [{ value: "", text: "--- ALL ---" }],
    );
    const tgl2 = moment(this.$store.state.user.tglaktif, "YYYY-MM-DD").add(1, "M").subtract(1, "day");
    // this.model.tgl1=this.$store.state.user.tglaktif;
    this.model.tgl2 = tgl2.format("YYYY-MM-DD");
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblOri.total = filteredItems.length;
      this.tblOri.page = 1;
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
    },
    getData: async function (ctx) {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.showSummary = true;
        this.isLoading = true;
        const result = await arreport.agingkolektor(this.model);
        this.isLoading = false;
        if (result.success) {
          this.aging.rekap = result.data[0];
          this.aging.detail = result.data[1];
          this.aging.valas = result.data[2];
          this.aging.seting = result.data[3][0];
          this.aging.totalLcy = 0;
          this.aging.aging1Lcy = 0;
          this.aging.aging2Lcy = 0;
          this.aging.aging3Lcy = 0;
          this.aging.aging4Lcy = 0;
          this.aging.aging5Lcy = 0;
          this.aging.rekap.forEach((ap) => {
            this.aging.totalLcy += ap.totalLcy;
            this.aging.aging1Lcy += ap.aging1Lcy;
            this.aging.aging2Lcy += ap.aging2Lcy;
            this.aging.aging3Lcy += ap.aging3Lcy;
            this.aging.aging4Lcy += ap.aging4Lcy;
            this.aging.aging5Lcy += ap.aging5Lcy;
          });
          // this.$forceUpdate();
          this.tblOri.total = this.aging.rekap.length;
          this.tblLcy.total = this.aging.rekap.length;
          if (result.message) toastr.warn(result.message, "WARNING", 10000);
        } else {
          if (result.message) toastr.error(result.message, "ERROR", 10000);
        }
      }
    },
    getDetail: function (row, col) {
      const setingan = this.aging.seting;
      if (row.custcode && row.totalOri != 0) {
        let pesan = `Showing Detail Invoices outstanding of  :  ${row.custcode.trim()} | ${row.CustName.trim()}`;
        switch (col) {
          case 0:
            pesan = pesan;
            break;
          case 1:
            pesan = pesan + '" Aging : ' + setingan["arAge" + col] + " days";
            break;
          case 2:
            pesan = pesan + '" Aging : ' + setingan["arAge" + col] + " days";
            break;
          case 3:
            pesan = pesan + '" Aging : ' + setingan["arAge" + col] + " days";
            break;
          case 4:
            pesan = pesan + '" Aging : ' + setingan["arAge" + col] + " days";
            break;
          case 5:
            pesan = pesan + '" Aging > ' + setingan["arAge" + col] + " days";
            break;
        }
        toastr.info(pesan);
        this.isLoading = true;
        this.agingDtl.list = [];
        this.agingDtl.outstand = 0;
        this.agingDtl.outstandLcy = 0;
        const lines = this.aging.detail.filter((d) => d.matauang == row.matauang && d.custcode == row.custcode && d.postgroup == row.postgroup);
        switch (col) {
          case 0:
            lines.forEach((trx) => {
              this.agingDtl.list.push(trx);
              this.agingDtl.outstand += trx.outstand;
              this.agingDtl.outstandLcy += trx.outstandLcy;
            });
            break;
          case 1:
            lines.forEach((trx) => {
              if (trx.aging <= setingan["arAge1"]) {
                this.agingDtl.list.push(trx);
                this.agingDtl.outstand += trx.outstand;
                this.agingDtl.outstandLcy += trx.outstandLcy;
              }
            });
            break;
          case 2:
            lines.forEach((trx) => {
              if (trx.aging > setingan["arAge1"] && trx.aging <= setingan["arAge2"]) {
                this.agingDtl.list.push(trx);
                this.agingDtl.outstand += trx.outstand;
                this.agingDtl.outstandLcy += trx.outstandLcy;
              }
            });
            break;
          case 3:
            lines.forEach((trx) => {
              if (trx.aging > setingan["arAge2"] && trx.aging <= setingan["arAge3"]) {
                this.agingDtl.list.push(trx);
                this.agingDtl.outstand += trx.outstand;
                this.agingDtl.outstandLcy += trx.outstandLcy;
              }
            });
            break;
          case 4:
            lines.forEach((trx) => {
              if (trx.aging > setingan["arAge3"] && trx.aging <= setingan["arAge4"]) {
                this.agingDtl.list.push(trx);
                this.agingDtl.outstand += trx.outstand;
                this.agingDtl.outstandLcy += trx.outstandLcy;
              }
            });
            break;
          case 5:
            lines.forEach((trx) => {
              if (trx.aging > setingan["arAge5"]) {
                this.agingDtl.list.push(trx);
                this.agingDtl.outstand += trx.outstand;
                this.agingDtl.outstandLcy += trx.outstandLcy;
              }
            });
            break;
        }
        this.showSummary = false;
        this.isLoading = false;
      }
    },

    // confirmAction: function() {
    //     toastr.info('Klik Pada TRX. NUMBER untuk PRINT VOUCHER');
    // },
    exportxls: async function () {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          const response = await arreport.agingkolektorexport(this.model);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message, "ERROR", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR", 10000);
          }
        }
      }
    },
    print: async function () {
      this.isLoading = true;
      try {
      this.reportUrl=null; this.showReport = true;
        this.reportUrl = await arreport.agingnoneketifprint(this.model);
        this.isLoading = false;
        if (this.$isMobile()) {
          this.showReport = false;
          window.location.href = `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
        }
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR", 10000);
        }
      }
    },

    close() {
      if (this.showSummary === true) {
        router.push("home");
      } else {
        this.showSummary = true;
      }
    },
  },
};
</script>
